var freeShippingThreshold = 200;
var cartTotal = 39; // dynamic from Shopify

var remaining = freeShippingThreshold - cartTotal;

if (remaining > 0) {
  message = "Add $" + remaining + " more to enjoy free delivery";
} else {
  message = "You have unlocked free delivery!";
}